import * as React from 'react';
import { observer } from 'mobx-react';

import { BOT_FATHER_LINK } from 'shared/entities/app';
import { TelegramChannelCreationStore } from 'stores/channelCreationStores';

import FormWithToken from '../FormWithToken';

type TelegramProps = {
  channelCreationStore: TelegramChannelCreationStore;
};

const BOT_FATHER_COMMAND = '/newbot';

const Telegram: React.FC<TelegramProps> = ({ channelCreationStore }) => {
  const token = channelCreationStore.token;

  return (
    <FormWithToken
      token={token}
      command={BOT_FATHER_COMMAND}
      url={BOT_FATHER_LINK}
      creatingBotName="BotFather"
      placeholder="000000000:XXXXXXXX..."
      onCreate={channelCreationStore.create}
      creatingStage={channelCreationStore.creationStage.value}
      disabled={channelCreationStore.isError}
    />
  );
};

export default observer(Telegram);
